import { Record, Set } from 'immutable';

export const messageFactory = new Record({
  id: '',
  type: 'info',
  text: '',
});

export const messagesFactory = (messages) => Set(messages.map(messageFactory));
